import { request } from '../index'
import { getCookieByName } from "../../utils"

export function getBranchAccounting() {
    return request({ "url": "branch/accouting/" })
}
export function createBranchAccounting(data) {
    return request({ "url": `branch/accouting/`, "method":"POST", data })
}
export function updateBranchAccounting(data) {
    return request({ "url": `branch/accouting/${data.id}/`, "method":"PUT", data })
}
export function deacrivateBranchAccounting(id) {
    return request({ "url": `branch/accouting/${id}/`, "method":"DELETE" })
}
export function dontGetAccounting(id) {
    return request({ "url": `branches/${id}/dont-get-accounting/`, "method":"PUT" })
}


// WEBPACK FOOTER //
// ./src/api/branches/accounting.js